import React, { useState, useEffect } from "react";
import ScaleContainer from "../scale-container";
import fallbackData from '../../data/de.json';

interface AppProps {
    language: string;
    pid?: string;
}

const App: React.FC<AppProps> = ({ language, pid }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            if (pid) {
                try {
                    const response = await fetch(`/data/${pid}/${language}.json`);
                    if (response.ok) {
                        const data = await response.json();
                        setData(data);
                        return;
                    }
                } catch (error) {
                    console.warn(`Failed to load data with pid "${pid}" for language "${language}":`, error);
                }
            }

            try {
                const response = await fetch(`/data/${language}.json`);
                const data = await response.json();
                setData(data);

                return;
            } catch (error) {
                console.error(`Error loading data for language "${language}":`, error);
            }
        };

        fetchData();
    }, [language, pid]);

    return <ScaleContainer tags={data ? data : fallbackData} />;
};
export default App;